<template>
    <ToolButton :Editor="Editor" KnownIcon="H2" @ToolClick="Editor.chain().focus().toggleHeading({level:2}).run()" 
        :class="{ 'toggled': Editor.isActive('heading', { level: 2 }) }">

    </ToolButton>
</template>
<script>

    import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

    export default({
        components:{
            ToolButton
        },
        props:["Editor"]
    });
</script>